/**
 * Notifications page.
 *
 * Reachable from the bell in the sidebar. Empty for now — the
 * notifications backend (delivery + read state + WebSocket fan-out) is
 * not implemented yet. Page exists so the bell has somewhere to land
 * and the empty-state copy sets expectations.
 */
import { Bell } from 'lucide-react';
import { Card } from '@/components/ui/card';

export function NotificationsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-primary/15 flex items-center justify-center shrink-0">
          <Bell className="h-5 w-5 text-primary-strong" />
        </div>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-foreground">Notifications</h1>
          <p className="text-sm text-muted-foreground">
            Scan completions, finding alerts, agent run updates, and platform announcements will land here.
          </p>
        </div>
      </div>

      <Card className="p-12 flex flex-col items-center text-center gap-3">
        <span className="text-5xl" role="img" aria-label="empty mailbox">📭</span>
        <p className="text-base font-semibold text-foreground">You're all caught up.</p>
        <p className="text-sm text-muted-foreground max-w-md">
          Nothing to read right now. We'll surface scan completions, new findings, and agent run alerts here as soon as the notifications service is live.
        </p>
      </Card>
    </div>
  );
}
